import { requests } from "../config";
import { IResponseSrikaNode } from "../Gathering/models/srika";
import {
  IWarehouseLocation,
  IWarehouseLocationCreate,
  IWarehouseLocationListFilters,
  IWarehouseLocationResponse,
  IWarehouseLocationUpdate,
  IWarehouseLocationsResponse,
} from "./models/locations";
import { ICoolingRoomsResponse } from "./models/rooms";
import { IBoundPalletToLocation, IExpirationReportFormRequest } from "./models/requests";
import { IExpirationReportResponse, IProductLocation } from "./models/responses";

// Reads only the named fields: useDataFetcher calls fetchers with a 'data' string.
const buildLocationListQuery = (filters?: IWarehouseLocationListFilters): string => {
  const params: string[] = [];
  if (filters?.type) params.push(`type=${filters.type}`);
  if (filters?.active === true) params.push('active=1');
  return params.length ? `?${params.join('&')}` : '';
}

export const Warehouse = {
  boundPalletToLocation: (data: IBoundPalletToLocation) => 
    requests.put(`entry/detail/locating`, 'go', data),
  getEntryDetailsByLocation: (data: string): Promise<IResponseSrikaNode> => requests.get(`entry/details/by_location?Location=${data}`, 'go'),
  // ProductID=1&VarietyID=23&SizeID=23&PackID=3
  getProductLocation: (data: string): Promise<IProductLocation> => requests.get(`entry/locations/by_product?${data}`, 'go'),
  getExpirationReport: (data: IExpirationReportFormRequest): Promise<IExpirationReportResponse> => requests.get(
    `warehouse/expiration/report?ProductID=${data.ProductID}&GrowerID=${data.GrowerID}&Location=${data.Location}&DaysToExpiration=${data.DaysToExpiration}&ExpirationFilter=${data.ExpirationFilter}&Occupancy=${data.Occupancy}&Tranzit=${data.Tranzit}`, 'go'),
  // Node server; no filters → all locations, type → ליקוט/אחסון only, active → active only.
  getLocationList: (filters?: IWarehouseLocationListFilters): Promise<IWarehouseLocationsResponse> =>
    requests.get(`warehouse/locations${buildLocationListQuery(filters)}`, 'node'),
  createLocation: (data: IWarehouseLocationCreate): Promise<IWarehouseLocationResponse> =>
    requests.post(`warehouse/locations`, 'node', data),
  // RecID travels in the body, not in the URL.
  updateLocation: (data: IWarehouseLocationUpdate): Promise<IWarehouseLocationResponse> =>
    requests.put(`warehouse/locations`, 'node', data),
  deleteLocation: (recId: number): Promise<{ message: string }> =>
    requests.delete(`warehouse/locations/${recId}`, 'node'),
  getRoomList: (): Promise<ICoolingRoomsResponse> => requests.get(`warehouse/rooms`, 'node'),
  // Server replies with the refreshed location list. Content-Type is left to
  // axios so the multipart boundary is generated correctly.
  uploadLocationsFile: (file: File, warehouseId: number): Promise<IWarehouseLocation[]> => {
    const formData = new FormData();
    formData.append('file', file);
    return requests.post(`warehouse/locations/upload?WarehouseID=${warehouseId}`, 'go', formData);
  },
}